import { StateCreator } from 'zustand';
import { PackageLine, DimensionUnit, WeightUnit } from '@freight-cbm/shared-types';

let nextId = 1;

function createId(): string {
  return `pkg-${nextId++}`;
}

export function resetPackageIdCounter(): void {
  nextId = 1;
}

export interface PackageSlice {
  packages: PackageLine[];
  addPackage: (partial?: Partial<PackageLine>) => void;
  removePackage: (id: string) => void;
  updatePackage: (id: string, field: keyof PackageLine, value: string | number | DimensionUnit | WeightUnit) => void;
  duplicatePackage: (id: string) => void;
  clearPackages: () => void;

}

const defaultLine = (): PackageLine => ({
  id: createId(),
  length: 0,
  width: 0,
  height: 0,
  dimUnit: DimensionUnit.Cm,
  weight: 0,
  weightUnit: WeightUnit.Kg,
  quantity: 1,
});

export const createPackageSlice: StateCreator<PackageSlice> = (set) => ({
  packages: [defaultLine()],
  addPackage: (partial) =>
    set((state) => ({
      packages: [...state.packages, { ...defaultLine(), ...partial }],
    })),
  removePackage: (id) =>
    set((state) => ({
      packages: state.packages.length <= 1
        ? state.packages
        : state.packages.filter((p) => p.id !== id),
    })),
  updatePackage: (id, field, value) =>
    set((state) => ({
      packages: state.packages.map((p) =>
        p.id === id ? { ...p, [field]: value } : p
      ),
    })),
  clearPackages: () => set({ packages: [defaultLine()] }),
  duplicatePackage: (id) =>
    set((state) => {
      const pkg = state.packages.find((p) => p.id === id);
      if (!pkg) return state;
      const idx = state.packages.indexOf(pkg);
      const newPkg = { ...pkg, id: createId() };
      const newPackages = [...state.packages];
      newPackages.splice(idx + 1, 0, newPkg);
      return { packages: newPackages };
    }),
});
